var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ModalHistory'),_c('div',{staticClass:"mt-3--xs",staticStyle:{"margin-top":"-5px"}},[_c('div',{staticClass:"content-text"}),_c('CounterActual')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }